import { IonDate } from "../components/IonDate";

const CheckNotNull = Symbol('CheckNotNull');

class InvoiceNote {
    public invoice_noteID: string = '';
    public title: string = '';
    public description: string = '';
    public apply_to_sec_half: boolean = false;
    public datetime_created: Date | null = null;

    constructor(
        invoice_noteID: string,
        title: string,
        description: string,
        apply_to_sec_half:string,
        datetime_created: string
    ) {
        this.invoice_noteID = this[CheckNotNull](invoice_noteID) ? invoice_noteID : '';
        this.title = this[CheckNotNull](title) ? title : '';
        this.description = this[CheckNotNull](description) ? description : '';
        this.apply_to_sec_half = this[CheckNotNull](apply_to_sec_half) ? (apply_to_sec_half == '0' ? false : true) : false;
        this.datetime_created = this[CheckNotNull](datetime_created) ? IonDate(datetime_created) : null;
    }

    private [CheckNotNull] = (value: string) => {
        if(value && value != null && value != 'null' && value.length > 0)
            return true;
        else
            return false;
    }
}
export default InvoiceNote;